import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const FolderPersonIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M13.3333 3.99984H7.99992L6.66659 2.6665H2.66659C1.93325 2.6665 1.33992 3.2665 1.33992 3.99984L1.33325 11.9998C1.33325 12.7332 1.93325 13.3332 2.66659 13.3332H13.3333C14.0666 13.3332 14.6666 12.7332 14.6666 11.9998V5.33317C14.6666 4.59984 14.0666 3.99984 13.3333 3.99984ZM13.3333 11.9998H2.66659V3.99984H6.11325L7.44659 5.33317H13.3333V11.9998ZM9.99992 8.6665C10.7333 8.6665 11.3333 8.0665 11.3333 7.33317C11.3333 6.59984 10.7333 5.99984 9.99992 5.99984C9.26659 5.99984 8.66659 6.59984 8.66659 7.33317C8.66659 8.0665 9.26659 8.6665 9.99992 8.6665ZM7.33325 11.3332H12.6666V10.6665C12.6666 9.77984 10.8866 9.33317 9.99992 9.33317C9.11325 9.33317 7.33325 9.77984 7.33325 10.6665V11.3332Z" />
  </Icon>
);

export default memo(FolderPersonIcon);
